import ArrowDownIcon from './ArrowDownIcon';
import ArrowUpIcon from './ArrowUpIcon';
import CheckIcon from './CheckIcon';
import CloseIcon from './CloseIcon';
import CogIcon from './CogIcon';
import CopyIcon from './CopyIcon';
import EditIcon from './EditIcon';
import EnableIcon from './EnableIcon';
import MoreIcon from './MoreIcon';
import ResetIcon from './ResetIcon';
import SearchIcon from './SearchIcon';
import TrashIcon from './TrashIcon';
export default Object.freeze({
  cog: CogIcon,
  more: MoreIcon,
  arrowDown: ArrowDownIcon,
  arrowUp: ArrowUpIcon,
  search: SearchIcon,
  reset: ResetIcon,
  close: CloseIcon,
  enable: EnableIcon,
  trash: TrashIcon,
  edit: EditIcon,
  check: CheckIcon,
  copy: CopyIcon
});